import { AxiosError } from 'axios'
import { useMemo } from 'react'
import { RolodexFileRef } from 'types'

import { useRolodexFileLSBulk } from './useRolodexFileListBulk'
export interface RolodexFileLSQueryBody {
  /** The ID of the entry to list files under */
  entry_id: string
  /** Path filtering docs on how to use https://geckorobotics.atlassian.net/wiki/spaces/SE/pages/4703354928/Moving+From+files+list+to+files+ls */
  path?: string
  /** Limit the number of files returned */
  limit?: number
}

/**
 * Proxies the query to the bulk endpoint to avoid duplicate implementations.
 *
 */
export const useRolodexFileLS = (
  query: RolodexFileLSQueryBody | undefined
): {
  /** An array of Rolodex file refs, useful for later loading */
  fileRefs: ReadonlyArray<RolodexFileRef>
  /** Whether the SWR query is still loading */
  isLoading: boolean
  /** Whether the SWR query is still validating */
  isValidating: boolean
  /** To account for the initial case before the query fires  */
  hasEverLoaded: boolean
  /** Any errors returned from SWR */
  error: AxiosError
  /** A callback for forcing a re-fetch */
  forceRefresh: () => Promise<void>
} => {
  //----------------------------------------------------------------------------
  const queryForBulkEndpoint = useMemo<
    ReadonlyArray<RolodexFileLSQueryBody>
  >(() => {
    if (!query) return []
    return [query]
  }, [query])

  const {
    fileRefs,
    isLoading,
    isValidating,
    error,
    hasEverLoaded,
    forceRefresh,
  } = useRolodexFileLSBulk(queryForBulkEndpoint)

  return {
    fileRefs,
    isLoading,
    isValidating,
    error,
    hasEverLoaded,
    forceRefresh,
  }
}
